import { render, staticRenderFns } from "./fpcForm.vue?vue&type=template&id=1db6905e&scoped=true"
import script from "./fpcForm.vue?vue&type=script&lang=js"
export * from "./fpcForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db6905e",
  null
  
)

export default component.exports